<div class="container-fluid" data-testid="admin-container">
  <div class="nav-bar" data-testid="navbar">
    <nav
      class="navbar navbar-expand-lg justify-content-between h-100"
      data-testid="main-navbar"
    >
      <div
        class="d-flex justify-content-between align-items-center"
        data-testid="navbar-header"
      >
        <div class="bar-head" data-testid="logo-section">
          <img
            src="assets/admin-nav/newbrijjLogo.svg"
            style="height: 3.8rem; width: 6rem"
            data-testid="logo-img"
          />
        </div>
        <!-- Breadcrumb Section -->
        <div class="breadcrumbs-section" data-testid="breadcrumbs-section">
          <img
            style="cursor: pointer"
            src="../../../../assets/Pos_sidebar/tdesign_component-breadcrumb.svg"
            data-testid="breadcrumb-icon"
          />
          <div
            class="menu d-flex align-items-center"
            data-testid="breadcrumb-menu"
          >
            <ul class="ps-0 mb-0" data-testid="breadcrumb-list">
              <li
                class="breadcrumb-item mb-0"
                id="firstItem"
                data-testid="breadcrumb-first"
              >
                <a
                  class="px-0 mx-0"
                  [routerLinkActive]="['active']"
                  [routerLink]="breadcrumbs[0]?.link"
                  (click)="getMenulinks(breadcrumbs[0]?.crumbName)"
                  data-testid="breadcrumb-link-0"
                >
                  {{ breadcrumbs[0]?.crumbName }}
                </a>
                <div
                  class="sub-menu"
                  [hidden]="
                    breadcrumbs[0]?.crumbName === 'Marketplace' ||
                    breadcrumbs[0]?.crumbName === 'Icons' ||
                    breadcrumbs[0]?.crumbName === 'Product Management'
                  "
                  data-testid="breadcrumb-submenu"
                >
                  <h6 data-testid="breadcrumb-submenu-title">
                    {{ breadcrumbs[0]?.crumbName }}
                  </h6>
                  <ul data-testid="breadcrumb-submenu-list">
                    <li
                      *ngFor="let item of mainLinks"
                      id="second"
                      data-testid="breadcrumb-submenu-item"
                    >
                      <a
                        [routerLinkActive]="['active']"
                        [routerLink]="item.link"
                        data-testid="breadcrumb-submenu-link"
                      >
                        <span
                          class="text"
                          data-testid="breadcrumb-submenu-text"
                          >{{ item.name }}</span
                        >
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <li
                class="breadcrumb-item mb-0"
                *ngFor="let crumb of breadcrumbs.slice(1)"
                data-testid="breadcrumb-other"
              >
                <a
                  [routerLinkActive]="['active']"
                  [routerLink]="crumb.link"
                  class="mx-0 ps-2"
                  data-testid="breadcrumb-link"
                  >{{ crumb.crumbName }}</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--user profile-->
      <div
        class="d-flex align-items-center justify-content-end"
        data-testid="profile-section"
      >
        <div class="d-flex" data-testid="profile-company">
          <div
            class="d-flex align-items-center"
            data-testid="profile-company-info"
          >
            <i
              class="fa-regular fa-building"
              style="color: #175f91; font-size: 22px"
              data-testid="company-icon"
            ></i>
            <p
              class="mb-0 text-nowrap ps-2 pe-4"
              style="font-size: 18px"
              data-testid="company-name"
            >
              {{ userInfo.company }}
            </p>
          </div>
          <div
            class="d-flex justify-content-end align-items-center"
            *ngIf="selectedcolor != undefined || selectedcolor != null"
            data-testid="week-section"
          >
            <h6
              class="mb-0 text-nowrap"
              style="font-size: 18px; font-weight: 500"
              data-testid="week-label"
            >
              Week &nbsp;:
            </h6>
            <span
              class="ms-2"
              [style.backgroundColor]="selectedcolor"
              id="weekColor"
              data-testid="week-color"
            ></span>
          </div>
        </div>

        <div class="bell-wrapper dropdown" data-testid="profile-dropdown">
          <button
            type="button"
            id="dropdownMenuButton22"
            data-bs-toggle="dropdown"
            aria-expanded="true"
            data-testid="profile-dropdown-btn"
          >
            <img
              width="20px"
              height="20px"
              src="../../../assets/icons/dots.svg"
              data-testid="profile-dropdown-icon"
            />
          </button>

          <div
            class="dropdown-menu custom-dropdown"
            aria-labelledby="dropdownMenuButton22"
            data-testid="profile-dropdown-menu"
          >
            <div class="icon-grid" data-testid="profile-dropdown-icons">
              <div
                class="icon-item"
                *ngIf="user.isPosPresent"
                (click)="user.isPosPresent ? redirectToModule(2) : ''"
                (contextmenu)="onRightClick($event, 2)"
                data-testid="profile-dropdown-pos"
              >
                <img
                  src="../../../assets/icons/posiconadduser.svg"
                  alt="POS Icon"
                  data-testid="profile-dropdown-pos-icon"
                />
                <span data-testid="profile-dropdown-pos-label">POS</span>
              </div>

              <div
                class="icon-item"
                *ngIf="user.isListerPresent"
                (click)="user.isListerPresent ? redirectToModule(4) : ''"
                (contextmenu)="onRightClick($event, 4)"
                data-testid="profile-dropdown-lister"
              >
                <img
                  src="../../../assets/icons/Lister_icon.svg"
                  alt="Lister Icon"
                  data-testid="profile-dropdown-lister-icon"
                />
                <span data-testid="profile-dropdown-lister-label">Lister</span>
              </div>

              <div
                class="icon-item"
                (click)="redirectToModule(6)"
                (contextmenu)="onRightClick($event, 6)"
                data-testid="profile-dropdown-company-portal"
              >
                <img
                  src="../../../assets/icons/newbrijjlogo.svg"
                  alt="Brijj Icon"
                  data-testid="profile-dropdown-company-portal-icon"
                />
                <span data-testid="profile-dropdown-company-portal-label"
                  >Company Portal</span
                >
              </div>

              <div
                class="icon-item"
                *ngIf="user.isinventoryPresent"
                (click)="user.isinventoryPresent ? redirectToModule(7) : ''"
                (contextmenu)="onRightClick($event, 7)"
                data-testid="profile-dropdown-ims"
              >
                <img
                  src="../../../assets/icons/listerlogo.svg"
                  alt="Lister Icon"
                  data-testid="profile-dropdown-ims-icon"
                />
                <span data-testid="profile-dropdown-ims-label">IMS</span>
              </div>
            </div>
          </div>
        </div>

        <div class="b-right" data-testid="profile-divider"></div>
        <div
          class="dropdown"
          (click)="handleDropdownToggle()"
          data-testid="user-dropdown"
        >
          <div
            class="user-profile"
            id="dropdownMenuButton2"
            data-bs-toggle="dropdown"
            aria-expanded="true"
            style="margin-right: 10px"
            data-testid="user-profile-btn"
          >
            <div
              class="d-flex align-items-center pe-3"
              data-testid="user-profile-info"
            >
              <div
                class="profile-pic"
                *ngIf="!userInfo.profileImgUrl"
                id="demoImg"
                data-testid="user-profile-pic-default"
              >
                <img
                  src="../../../assets/adminprofile/kevin.png"
                  data-testid="user-profile-img-default"
                />
              </div>
              <div
                class="profile-pic border"
                *ngIf="userInfo.profileImgUrl"
                data-testid="user-profile-pic"
              >
                <img
                  class="w-100"
                  [src]="userInfo.profileImgUrl"
                  data-testid="user-profile-img"
                />
              </div>
              <div class="user-name" data-testid="user-profile-name">
                <h3
                  class="name"
                  *ngIf="!userInfo.displayName"
                  data-testid="user-profile-fullname"
                >
                  {{ userInfo.fullName }}
                </h3>
                <h3
                  class="name"
                  *ngIf="userInfo.displayName"
                  data-testid="user-profile-displayname"
                >
                  {{ userInfo.displayName }}
                </h3>
                <div
                  class="d-flex position-relative"
                  data-testid="user-profile-roles"
                >
                  <h6
                    class="secondary mb-0"
                    id="id_userRole"
                    data-testid="user-profile-role"
                  >
                    {{
                      currentUserRoles?.length > 0
                        ? currentUserRoles[0]?.name
                        : ""
                    }}
                  </h6>
                  <div
                    *ngIf="currentUserRoles?.length > 1"
                    class="c-pt view-more ms-1 position-relative role-hover-group"
                    data-testid="user-profile-role-more"
                  >
                    <h6
                      class="secondary mb-0"
                      id="id_userRole"
                      data-testid="user-profile-role-count"
                    >
                      +{{ currentUserRoles?.length - 1 }}
                    </h6>
                    <ul class="show-list" data-testid="user-profile-role-list">
                      <li
                        style="color: #ffffff; padding-block: 2px"
                        *ngFor="let rl of currentUserRoles.slice(1)"
                        data-testid="user-profile-role-item"
                      >
                        {{ rl.name }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <i
              [class.rotate-icon]="isDropdownOpen"
              class="fa-solid fa-chevron-down text-black"
              data-testid="user-profile-dropdown-icon"
            ></i>
          </div>
          <ul
            class="dropdown-menu"
            aria-labelledby="dropdownMenuButton2"
            data-testid="user-profile-dropdown-menu"
          >
            <li
              *ngIf="
                selectedcolor != undefined ||
                selectedcolor != null ||
                productionScheduleType == 'DateSpecific'
              "
              data-testid="switch-to-productionsystem"
            >
              <a
                class="dropdown-item"
                (click)="changeModule()"
                data-testid="switch-to-productionsystem-link"
              >
                <i
                  class="fa-solid fa-right-left"
                  style="
                    color: #175f91;
                    font-size: 18px;
                    margin-right: 17px;
                    font-weight: 100;
                  "
                  data-testid="switch-to-productionsystem-icon"
                ></i
                >Switch to Production
              </a>
            </li>
            <li href="/" data-testid="user-profile-logout">
              <a
                class="dropdown-item"
                (click)="logout()"
                data-testid="user-profile-logout-link"
              >
                <img
                  class="me-3"
                  src="../../assets/admin-nav/ic_logout.svg"
                  data-testid="user-profile-logout-icon"
                />Logout
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
  <div class="admin-main-content d-flex" data-testid="main-content">
    <div class="sidebar" data-testid="sidebar">
      <div class="sidebar-wrapper" data-testid="sidebar-wrapper">
        <div class="bar-options" data-testid="sidebar-options">
          <div class="w-100" data-testid="sidebar-menu">
            <div class="menu" data-testid="sidebar-menu-list">
              <ul class="ps-0" data-testid="sidebar-menu-ul">
                <li
                  [ngClass]="{ active: isMenuItemActive[0] }"
                  data-testid="sidebar-dashboard"
                >
                  <div
                    class="descrWrap"
                    (click)="hideMenu()"
                    data-testid="sidebar-dashboard-wrap"
                  >
                    <a
                      class="cst-m first-a"
                      routerLink="/admin/home/admin-home"
                      (click)="getDataForMenu(0)"
                      data-testid="sidebar-dashboard-link"
                    >
                      <img
                        src="../../../../assets/Pos_sidebar/dashboard.svg"
                        data-testid="sidebar-dashboard-icon"
                      />
                    </a>
                    <span class="text" data-testid="sidebar-dashboard-text"
                      >Dashboard</span
                    >
                  </div>
                </li>
                <!--  Dashboard Section -->
                <li
                  [ngClass]="{ active: isMenuItemActive[1] }"
                  *ngIf="allMenus[0].submenus.submenuArray.length > 0"
                  data-testid="sidebar-reports"
                >
                  <div
                    class="descrWrap"
                    style="padding-left: 9px"
                    data-testid="sidebar-reports-wrap"
                  >
                    <a
                      class="cst-m first-a"
                      (click)="onMainMenuClick(1, 0)"
                      data-testid="sidebar-reports-link"
                    >
                      <img
                        src="../../../../assets/Pos_sidebar/up_report.svg"
                        data-testid="sidebar-reports-icon"
                      />
                    </a>
                    <span data-testid="sidebar-reports-text">Reports</span>
                  </div>
                  <div
                    class="sub-menu-wrp"
                    [ngClass]="{ open: IsMenuopen }"
                    data-testid="sidebar-reports-submenu-wrp"
                  >
                    <div
                      class="sub-menu"
                      [ngClass]="{ open: IsMenuopen }"
                      data-testid="sidebar-reports-submenu"
                    >
                      <h6 data-testid="sidebar-reports-submenu-title">
                        Reports
                      </h6>
                      <ul
                        class="sub-ul"
                        data-testid="sidebar-reports-submenu-list"
                      >
                        <ng-template
                          [ngxPermissionsOnly]="['Report:ViewEmployee']"
                        >
                          <li data-testid="sidebar-reports-employee">
                            <a
                              [routerLinkActive]="['active']"
                              [routerLink]="empReportRoute"
                              data-testid="sidebar-reports-employee-link"
                            >
                              <span
                                class="text"
                                data-testid="sidebar-reports-employee-text"
                                >Employee Report</span
                              >
                            </a>
                          </li>
                        </ng-template>
                        <ng-template
                          [ngxPermissionsOnly]="[
                            'Report:ViewProductionOverview'
                          ]"
                        >
                          <li data-testid="sidebar-reports-production-overview">
                            <a
                              [routerLinkActive]="['active']"
                              [routerLink]="productionOverviewRoute"
                              data-testid="sidebar-reports-production-overview-link"
                            >
                              <span
                                class="text"
                                data-testid="sidebar-reports-production-overview-text"
                                >Production Overview</span
                              >
                            </a>
                          </li>
                        </ng-template>
                        <ng-template
                          [ngxPermissionsOnly]="['Report:ViewTopPerformer']"
                        >
                          <li data-testid="sidebar-reports-top-performer">
                            <a
                              [routerLinkActive]="['active']"
                              [routerLink]="topPerformerRoute"
                              data-testid="sidebar-reports-top-performer-link"
                            >
                              <span
                                class="text"
                                data-testid="sidebar-reports-top-performer-text"
                                >Top Performer</span
                              >
                            </a>
                          </li>
                        </ng-template>
                        <ng-template
                          [ngxPermissionsOnly]="['Report:ViewSellThrough']"
                        >
                          <li data-testid="sidebar-reports-sell-through">
                            <a
                              [routerLinkActive]="['active']"
                              [routerLink]="sellThroughRoute"
                              data-testid="sidebar-reports-sell-through-link"
                            >
                              <span
                                class="text"
                                data-testid="sidebar-reports-sell-through-text"
                                >Sell Through Report</span
                              >
                            </a>
                          </li>
                        </ng-template>
                        <ng-template
                          [ngxPermissionsOnly]="['Report:ViewSellThrough']"
                        >
                          <li data-testid="sidebar-reports-sell-through">
                            <a
                              [routerLinkActive]="['active']"
                              [routerLink]="salePerProducerRoute"
                              data-testid="sidebar-reports-sale-per-producer-link"
                            >
                              <span
                                class="text"
                                data-testid="sidebar-reports-sale-per-producer-text"
                                >Sales Productivity Report</span
                              >
                            </a>
                          </li>
                        </ng-template>
                      </ul>
                    </div>
                  </div>
                </li>
                <li
                  [ngClass]="{ active: isMenuItemActive[4] }"
                  *ngIf="analyticsSubmenus.length > 0"
                  data-testid="sidebar-analytics"
                >
                  <div
                    class="descrWrap"
                    style="padding-left: 9px"
                    data-testid="sidebar-analytics-wrap"
                  >
                    <a
                      class="cst-m first-a"
                      (click)="getDataForMenu(4)"
                      data-testid="sidebar-analytics-link"
                    >
                      <img
                        src="../../../../assets/Pos_sidebar/up_report.svg"
                        data-testid="sidebar-analytics-icon"
                      />
                    </a>
                    <span data-testid="sidebar-analytics-text">Analytics</span>
                  </div>
                  <div
                    class="sub-menu-wrp"
                    [ngClass]="{ open: IsMenuopen }"
                    data-testid="sidebar-analytics-submenu-wrp"
                  >
                    <div
                      class="sub-menu"
                      [ngClass]="{ open: IsMenuopen }"
                      data-testid="sidebar-analytics-submenu"
                    >
                      <h6 data-testid="sidebar-analytics-submenu-title">
                        Analytics
                      </h6>
                      <ul
                        class="sub-ul"
                        data-testid="sidebar-analytics-submenu-list"
                      >
                        <li
                          *ngFor="let item of analyticsSubmenus"
                          data-testid="sidebar-analytics-item"
                        >
                          <a
                            [routerLink]="item.link"
                            [routerLinkActive]="['active']"
                            data-testid="sidebar-analytics-item-link"
                          >
                            <span
                              class="text"
                              data-testid="sidebar-analytics-item-text"
                            >
                              {{ item.menuName }}
                            </span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
                <!-- Store Management Section -->
                <ng-template [ngxPermissionsOnly]="['Station:View']">
                  <li
                    [ngClass]="{ active: isMenuItemActive[2] }"
                    data-testid="sidebar-stations"
                  >
                    <div
                      class="descrWrap"
                      style="padding-left: 9px"
                      (click)="hideMenu()"
                      data-testid="sidebar-stations-wrap"
                    >
                      <a
                        (click)="getDataForMenu(2)"
                        class="cst-m first-a"
                        routerLink="/admin/home/stations"
                        data-testid="sidebar-stations-link"
                      >
                        <img
                          src="../../../../assets/Pos_sidebar/store_management.svg"
                          data-testid="sidebar-stations-icon"
                        />
                      </a>
                      <span class="text" data-testid="sidebar-stations-text"
                        >Stations</span
                      >
                    </div>
                  </li>
                </ng-template>
                <!-- Company Config Section -->
                <li
                  [ngClass]="{ active: isMenuItemActive[3] }"
                  *ngIf="allMenus[1].submenus.submenuArray.length > 0"
                  data-testid="sidebar-company"
                >
                  <div
                    class="descrWrap"
                    style="padding-left: 5px"
                    data-testid="sidebar-company-wrap"
                  >
                    <a
                      class="first-a"
                      (click)="onMainMenuClick(3, 1)"
                      data-testid="sidebar-company-link"
                    >
                      <img
                        src="../../../../assets/Pos_sidebar/company_config.svg"
                        data-testid="sidebar-company-icon"
                      />
                    </a>
                    <span data-testid="sidebar-company-text">Company </span>
                  </div>
                  <div
                    class="sub-menu-wrp"
                    [ngClass]="{ open: IsMenuopen }"
                    data-testid="sidebar-company-submenu-wrp"
                  >
                    <div
                      class="sub-menu"
                      [ngClass]="{ open: IsMenuopen }"
                      data-testid="sidebar-company-submenu"
                    >
                      <h6 data-testid="sidebar-company-submenu-title">
                        Company Config
                      </h6>
                      <ul
                        class="sub-ul"
                        data-testid="sidebar-company-submenu-list"
                      >
                        <ng-template [ngxPermissionsOnly]="['Goal:View']">
                          <li data-testid="sidebar-company-goals">
                            <a
                              [routerLinkActive]="['active']"
                              routerLink="/admin/home/goals"
                              data-testid="sidebar-company-goals-link"
                            >
                              <span
                                class="text"
                                data-testid="sidebar-company-goals-text"
                                >Goals</span
                              >
                            </a>
                          </li>
                        </ng-template>
                        <ng-template [ngxPermissionsOnly]="['Label:View']">
                          <li data-testid="sidebar-company-labels">
                            <a
                              [routerLinkActive]="['active']"
                              routerLink="/admin/home/labels"
                              data-testid="sidebar-company-labels-link"
                            >
                              <span
                                class="text"
                                data-testid="sidebar-company-labels-text"
                                >Print Formats</span
                              >
                            </a>
                          </li>
                        </ng-template>
                        <ng-template [ngxPermissionsOnly]="['Pricing:View']">
                          <li data-testid="sidebar-company-pricing">
                            <a
                              [routerLinkActive]="['active']"
                              routerLink="/admin/home/pricing/pricing-config"
                              data-testid="sidebar-company-pricing-link"
                            >
                              <span
                                class="text"
                                data-testid="sidebar-company-pricing-text"
                                >Pricing</span
                              >
                            </a>
                          </li>
                        </ng-template>
                        <ng-template
                          [ngxPermissionsOnly]="['Quality:View']"
                          ||
                          [ngxPermissionsOnly]="['Condition:View']"
                        >
                          <li data-testid="sidebar-company-quality">
                            <a
                              [routerLinkActive]="['active']"
                              routerLink="/admin/home/grades"
                              data-testid="sidebar-company-quality-link"
                            >
                              <span
                                class="text"
                                data-testid="sidebar-company-quality-text"
                                >Quality & Conditions</span
                              >
                            </a>
                          </li>
                        </ng-template>
                        <ng-template [ngxPermissionsOnly]="['Size:View']">
                          <li data-testid="sidebar-company-sizes">
                            <a
                              [routerLinkActive]="['active']"
                              routerLink="/admin/home/sizing"
                              data-testid="sidebar-company-sizes-link"
                            >
                              <span
                                class="text"
                                data-testid="sidebar-company-sizes-text"
                                >Sizes</span
                              >
                            </a>
                          </li>
                        </ng-template>
                        <ng-template [ngxPermissionsOnly]="['WeekColor:View']">
                          <li
                            *ngIf="showWeekColorsMenu"
                            data-testid="sidebar-company-week-colors"
                          >
                            <a
                              [routerLinkActive]="['active']"
                              routerLink="/admin/home/week-colors"
                              data-testid="sidebar-company-week-colors-link"
                            >
                              <span
                                class="text"
                                data-testid="sidebar-company-week-colors-text"
                                >Week Colors</span
                              >
                            </a>
                          </li>
                        </ng-template>
                      </ul>
                    </div>
                  </div>
                </li>
                <!-- Inventory Management Section -->
                <li
                  [ngClass]="{ active: isMenuItemActive[5] }"
                  *ngIf="allMenus[2].submenus.submenuArray.length > 0"
                  data-testid="sidebar-inventory"
                >
                  <div
                    class="descrWrap"
                    style="padding-left: 5px"
                    data-testid="sidebar-inventory-wrap"
                  >
                    <a
                      class="first-a"
                      (click)="onMainMenuClick(5, 2)"
                      data-testid="sidebar-inventory-link"
                    >
                      <img
                        src="../../../../assets/Pos_sidebar/inventory_2.svg"
                        data-testid="sidebar-inventory-icon"
                      />
                    </a>
                    <span data-testid="sidebar-inventory-text">Inventory </span>
                  </div>
                  <div
                    class="sub-menu-wrp"
                    [ngClass]="{ open: IsMenuopen }"
                    data-testid="sidebar-inventory-submenu-wrp"
                  >
                    <div
                      class="sub-menu"
                      [ngClass]="{ open: IsMenuopen }"
                      data-testid="sidebar-inventory-submenu"
                    >
                      <h6 data-testid="sidebar-inventory-submenu-title">
                        Inventory Management
                      </h6>
                      <ul
                        class="sub-ul"
                        data-testid="sidebar-inventory-submenu-list"
                      >
                        <ng-template
                          [ngxPermissionsOnly]="['Item:ViewItemsOnHand']"
                        >
                          <li data-testid="sidebar-inventory-onhands">
                            <a
                              [routerLinkActive]="['active']"
                              routerLink="/admin/home/onhands"
                              data-testid="sidebar-inventory-onhands-link"
                            >
                              <span
                                class="text"
                                data-testid="sidebar-inventory-onhands-text"
                                >Items On Hand</span
                              >
                            </a>
                          </li>
                        </ng-template>
                        <ng-template
                          [ngxPermissionsOnly]="['WeekColor:Override']"
                        >
                          <li data-testid="sidebar-inventory-overrides">
                            <a
                              [routerLinkActive]="['active']"
                              routerLink="/admin/home/overrides"
                              data-testid="sidebar-inventory-overrides-link"
                            >
                              <span
                                class="text"
                                data-testid="sidebar-inventory-overrides-text"
                                >Overrides</span
                              >
                            </a>
                          </li>
                        </ng-template>
                        <ng-template [ngxPermissionsOnly]="['Bin:View']">
                          <li data-testid="sidebar-inventory-containers">
                            <a
                              [routerLinkActive]="['active']"
                              routerLink="/admin/home/containers"
                              data-testid="sidebar-inventory-containers-link"
                            >
                              <span
                                class="text"
                                data-testid="sidebar-inventory-containers-text"
                                >Production Bins</span
                              >
                            </a>
                          </li>
                        </ng-template>
                      </ul>
                    </div>
                  </div>
                </li>
                <!-- Barcode Section -->
                <li
                  [ngClass]="{ active: isMenuItemActive[6] }"
                  data-testid="sidebar-barcode"
                >
                  <div
                    class="descrWrap"
                    style="padding-left: 9px"
                    (click)="hideMenu()"
                    data-testid="sidebar-barcode-wrap"
                  >
                    <a
                      (click)="getDataForMenu(6)"
                      class="cst-m"
                      routerLink="/admin/home/barcode"
                      data-testid="sidebar-barcode-link"
                    >
                      <i
                        class="fa-solid fa-barcode"
                        style="color: #175f91; font-size: 22px"
                        data-testid="sidebar-barcode-icon"
                      ></i>
                    </a>
                    <span class="text" data-testid="sidebar-barcode-text"
                      >Barcode</span
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 content-container" data-testid="content-container">
      <router-outlet data-testid="router-outlet"></router-outlet>
    </div>
  </div>
  <div
    *ngIf="showContextMenu"
    [ngStyle]="{ top: contextMenuPosition.y, left: contextMenuPosition.x }"
    class="custom-context-menu"
    (click)="openInNewTab()"
    data-testid="custom-context-menu"
  >
    Open in new tab
  </div>
</div>
